import script from "./ManualsGuide.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManualsGuide.vue?vue&type=script&setup=true&lang=ts"

import "./ManualsGuide.vue?vue&type=style&index=0&id=004cba6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-004cba6f"]])

export default __exports__